import React from 'react';
import { Label } from '../../ui/label';

// Shared field chrome for the booking-link editor's sections (#685).

export function FieldLabel({ htmlFor, children, className = '' }) {
    return (
        <Label htmlFor={htmlFor} className={`text-[11px] font-semibold tracking-wider text-stone-500 uppercase ${className}`}>
            {children}
        </Label>
    );
}

export function FieldHint({ children, ...props }) {
    return <p className="text-xs text-stone-500 mt-1" {...props}>{children}</p>;
}

/** Inline error; pair with `errorProps(id, error)` on the control. */
export function FieldError({ id, error }) {
    if (!error) return null;
    return <p id={`${id}-error`} className="text-xs text-red-600 mt-1" role="alert">{error}</p>;
}

export const errorProps = (id, error) => (error
    ? { 'aria-invalid': true, 'aria-describedby': `${id}-error` }
    : {});
